import request from '@/utils/request'

export function logOut(params) {
    return request({
        url: '/api/v1/auth/logout',
        method: 'get',
        params: params
    })
}
export function mobileRegister(data) {
    return request({
        url: '/api/v1/auth/mobile/register',
        method: 'post',
        data: data
    })
}
/**
 * 
 * @param {loginName, password} data 
 * @returns 
 */
export function accountLogin(data) {
    return request({
        url: '/api/v1/auth/account/login',
        method: 'post',
        data: data
    })
}
/**
 * 
 * @param {mobile,type} data  type: REGISTER-注册 LOGIN-登录 CHANGE-重置密码
 * @returns 
 */
export function getMobileCaptcha(data) {
    return request({
        url: '/api/v1/auth/mobile/captcha',
        method: 'post',
        data: data
    })
}
/**
 * 
 * @param { mobile, verifyCode, verifyCodeKey } data 
 * @returns 
 */
export function mobileLogin(data) {
    return request({
        url: '/api/v1/auth/mobile/login',
        method: 'post',
        data: data
    })
}
/**
 * 
 * @param { mobile, password, verifyCode, verifyCodeKey } data 
 * @returns 
 */
export function resetPassword(data) {
    return request({
        url: '/api/v1/auth/reset/password',
        method: 'post',
        data: data
    })
}

/**
 * 
 * @param { mobile, password, verifyCode, verifyCodeKey } data 
 * @returns 
 */
 export function getTemporaryToken(params) {
    return request({
        url: '/api/v1/auth/token',
        method: 'get',
        params: params
    })
}